import { css } from 'emotion'

export const marginTopMediumStyles = css`
  margin-top: 16px;
`
